import { createEvent, createStore } from 'effector';
export const setShowLevelDetails = createEvent();
export const handleLevel = createEvent();
export const levelDetails = createStore(null).on(handleLevel, (_, payload) => payload);
export const showLevelsDetails = createStore(false).on(setShowLevelDetails, (_, payload) => payload);
